import { createSlice } from '@reduxjs/toolkit';

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const entitySalePromotionSlice = createSlice({
  name: 'entitySalePromotion',
  initialState,
  reducers: {
    reloadEntitySalePromotion(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationEntitySalePromotion(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListEntitySalePromotion(state, action) {
      state.savedList = action.payload;
    },
  },
});

const { actions, reducer: entitySalePromotionReducer } =
  entitySalePromotionSlice;

export const {
  reloadEntitySalePromotion,
  updateSavedPaginationEntitySalePromotion,
  updateSavedListEntitySalePromotion,
} = actions;

export default entitySalePromotionReducer;
